<template>
  <client-layout>
    <div>
      <new-site-dialog
        @close="isNewSiteDialogOpened = false"
        @created="newSiteCreated"
        :maker-id="company.id"
        :client-id="currentAdminClient.id"
        v-if="isNewSiteDialogOpened"
      />
      <site-dialog
        v-model="isSiteDialogOpened"
        :site="selectedSite"
        @save="stateSave"
        @close="resetSelectedSite"
        :client="currentAdminClient"
        :maker="company"
        v-if="isSiteDialogOpened"
      />
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Sites</span>
        <v-spacer></v-spacer>
        <v-btn :disabled="!$canWrite" v-if="canAddSite" @click="$canWrite && (isNewSiteDialogOpened = true)" dark color="primary" elevation="0">
          <v-icon left>add</v-icon>
          Nouveau site
        </v-btn>
      </v-row>
      <v-col class="py-2 search-bar border-component">
        <v-text-field
          v-model="searchString"
          placeholder="Rechercher un site..."
          prepend-icon="search"
          hide-details
          dense
          clearable
          class="input-no-b-line"
        ></v-text-field>
      </v-col>
      <v-col class="pa-0 pt-4">
        <n-card depressed style="min-height: 6px;">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
            class="absolute-progress"
            v-if="isFetchingSites"
          />
          <v-list two-line class="pa-0">
            <template v-for="(site, index) in filteredSites">
              <v-list-item
                :key="`site-${index}`"
                @click="openSite(site)"
              >
                <v-list-item-avatar>
                  <v-icon>place</v-icon>
                </v-list-item-avatar>

                <v-row no-gutters>
                  <v-col align="left">
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-row no-gutters justify="center" align="center">
                          {{ site.name }}
                          <v-spacer />
                        </v-row>
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="site.$fullAddress.length || site.$phone1.length">
                        <v-row no-gutters>
                          <v-col align="left">
                            {{ site.$fullAddress }}
                          </v-col>
                          <v-col align="right">
                            <v-icon small class="pb-1" v-if="site.$phone1.length">phone</v-icon>
                            {{ site.$phone1 }}
                          </v-col>
                        </v-row>
                      </v-list-item-subtitle>
                      <v-list-item-content class="pb-0 pt-1" v-if="site.makerTags.length">
                        <div>
                          <tag-chip v-for="tag in site.makerTags" :key="`tag-${tag.id}`" :tag="tag" />
                        </div>
                      </v-list-item-content>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-divider
                v-if="index + 1 < filteredSites.length"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </n-card>
      </v-col>
    </div>
  </client-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import ClientLayout from '@/views/settings/clients/ClientLayout.vue';
import NewSiteDialog from '@/components/NewSiteModal.vue';
import SiteDialog from '@/components/SiteDialog.vue';

export default {
  name: `SettingsClientSites`,
  data: () => ({
    isFetchingSites: false,
    isNewSiteDialogOpened: false,
    isSiteDialogOpened: false,
    selectedSite: {},
  }),
  computed: {
    ...mapState(`ui/sitesList`, {
      storeSearchString: `searchString`,
    }),
    searchString: {
      get() {
        return this.storeSearchString;
      },
      set(searchString) {
        this.setSearchString(searchString);
      },
    },
    ...mapState(`model/site`, {
      storeSites: `sites`,
      // storeSites: state => _
      //   .orderBy(state.sites, `name`)
      //   .map(site => ({
      //     ...site,
      //     searchString: _.lowerCase(site.name),
      //   })),
    }),
    ...mapState(`model/client`, [
      `company`,
      `isMaker`,
      `isSelfMaker`,
      `currentAdminClient`,
    ]),
    canAddSite() {
      return (this.currentAdminClient.slug === `` || !this.company.isRoot)
             && ([`aba`, `sushi-robots`, `techni-froid-cuisines`].indexOf(this.company.slug) === -1 || this.isDemoApp);
    },
    flavoredSites() {
      return _.chain(this.storeSites)
        .map(site => {
          const address = _.trim(site.address || ``);
          const postalCodeAndCity = _.trim(`${site.postalCode || ``} ${site.city || ``}`);
          const hasAddressAndPostalCodeOrCity = Boolean(address.length && postalCodeAndCity.length);
          return {
            ...site,
            clientTags: _.sortBy(site.clientTags || [], tag => _.toLower(tag.label)),
            makerTags: _.sortBy(site.makerTags || [], tag => _.toLower(tag.label)),
            $fullAddress: _.trim(`${address} ${hasAddressAndPostalCodeOrCity ? `-` : ``} ${postalCodeAndCity}`),
            $phone1: _.trim(site.phone1 || ``),
            $searchString: _.toLower(`${site.name} ${address} ${postalCodeAndCity} ${site.tenant} ${site.owner} ${site.Zelok_id || ``}`.replace(/ {2}/g, ` `)),
          };
        })
        .sortBy(`$searchString`)
        .value();
    },
    filteredSites() {
      let sites = this.flavoredSites;
      if (this.searchString) {
        this.searchString.split(` `).forEach(searchStringPart => {
          searchStringPart = _.toLower(searchStringPart);
          sites = _.filter(sites, site =>
            site.$searchString.indexOf(searchStringPart) !== -1
          );
        });
      }
      return sites;
    },
  },
  methods: {
    ...mapActions(`model/site`, {
      fetchList: `fetchSites`,
      fetchListForMaker: `fetchSitesForMakerAndClient`,
    }),
    setSearchString(searchString) {
      this.$store.commit(`ui/sitesList/SET_SEARCH_STRING`, searchString);
    },
    async fetchSites() {
      this.isFetchingSites = true;
      if (this.isMaker || this.isSelfMaker) {
        await this.fetchListForMaker({
          clientId: this.currentAdminClient.id,
          makerId: this.company.id,
          setList: true,
        });
      } else {
        await this.fetchList();
      }
      this.isFetchingSites = false;
    },
    openSite(site) {
      this.selectedSite = site;
      this.isSiteDialogOpened = true;
    },
    async stateSave() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: this.selectedSite && this.selectedSite.id ? `Site modifié avec succès` : `Site créé avec succès`,
      });
      this.selectedSite = {};
    },
    newSiteCreated() {
      this.isNewSiteDialogOpened = false;
      this.fetchSites();
    },
    resetSelectedSite() {
      this.selectedSite = {};
    },
  },
  beforeMount() {
    this.fetchSites();
  },
  components: {
    ClientLayout,
    NewSiteDialog,
    SiteDialog,
  },
};
</script>

<style lang="scss">
</style>
